module.exports = __webpack_public_path__ + "media/images/icons/link-external-c50cd216eae5c56c266ba37e35b47263.svg";